import styled from 'styled-components';

export const Wrapper = styled.div`
	&.consentDefault {
		margin-top: 1.5rem;

		.consentLabel {
			display: flex;
			align-items: flex-start;
			margin: 0;
			cursor: pointer;
			font-family: Nunito, sans-serif;
			font-style: normal;
			font-weight: normal;
			font-size: 0.875rem;
			line-height: 150%;
			color: #4f4f4f;
			text-align: left;

			input[type='checkbox'] {
				flex: 0 0 auto;
				width: 18px;
				height: 18px;
				margin: 2px 0.625rem 0 0;
				cursor: pointer;
				accent-color: #009ddb;
			}

			a {
				color: #009ddb;
				font-weight: bold;
				text-decoration: underline;
			}

			&.invalidForm {
				color: #eb5757;
			}
		}
	}
`;

export default Wrapper;
